import { render, staticRenderFns } from "./changecourse.vue?vue&type=template&id=b9a771e4&scoped=true"
import script from "./changecourse.vue?vue&type=script&lang=js"
export * from "./changecourse.vue?vue&type=script&lang=js"
import style0 from "./changecourse.vue?vue&type=style&index=0&id=b9a771e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a771e4",
  null
  
)

export default component.exports